import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [];

export const dictionary = {
		"/": [2],
		"/account": [3],
		"/account/confirm-user/[userId]/[code]": [4],
		"/account/profile": [5],
		"/admin/base-data/line": [6],
		"/admin/base-data/pole": [7],
		"/admin/companies/[[company_id]]/user/new": [10],
		"/admin/companies/[[company_id]]/user/[user_id]": [9],
		"/admin/companies/[[company_id]]": [8],
		"/admin/data-management": [11],
		"/admin/globals": [12],
		"/auth": [13],
		"/condition-templates": [14],
		"/dashboards/aviationobstacles": [15],
		"/login": [16],
		"/logout": [17],
		"/map": [18],
		"/reports/new-capacity-report": [19],
		"/reports/pole-capacity-report": [20],
		"/reports/polygon-capacity-report": [21],
		"/reports/polygon-section-calculation": [22],
		"/smartdata": [23]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';